// src/components/layout/Footer.jsx
import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-100 border-t border-gray-200 px-6 py-3">
      <div className="text-center">
        <p className="text-sm text-gray-500">
          AIM-100 AIMEE&#8480; Dashboard Version 2.0
        </p>
      </div>
    </footer>
  );
};

export default Footer;